import { render } from "./FleetShow.vue?vue&type=template&id=1cbe652a&scoped=true"
import script from "./FleetShow.vue?vue&type=script&lang=js"
export * from "./FleetShow.vue?vue&type=script&lang=js"

import "./FleetShow.vue?vue&type=style&index=0&id=1cbe652a&scoped=true&lang=css"

import exportComponent from "C:\\docker\\bene_piscinas_front_end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cbe652a"]])

export default __exports__